import { render, staticRenderFns } from "./SafeCheck.vue?vue&type=template&id=504e521e&scoped=true&"
import script from "./SafeCheck.vue?vue&type=script&lang=js&"
export * from "./SafeCheck.vue?vue&type=script&lang=js&"
import style0 from "./SafeCheck.vue?vue&type=style&index=0&id=504e521e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e521e",
  null
  
)

export default component.exports